import { Badge } from '@mui/material'
import { ProductIconst } from 'src/components/pages/sales/reservation/logic/productsConst'
import { styled } from '@mui/material/styles'

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: -6,
    top: 9,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 3px',
    fontSize: '11px'
  },
}));

export const iconAccordingProduct = (products) => {
  if (Array.isArray(products)) {
    const productCounts = products.reduce((acc, item) => {
      const ref = item.product.ref_table_detail
      acc[ref] = (acc[ref] || 0) + 1
      return acc
    }, {})

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
        {Object.entries(productCounts).map(([key, count], index) => (
          <StyledBadge key={index} badgeContent={count} color='primary' sx={{ margin: '0 2px 0 2px' }}>
            {ProductIconst[key]}
          </StyledBadge>
        ))}
      </div>
    )
  }

  if (typeof products === 'string') {
    return ProductIconst[products]
  }
}
